import { render } from "./Links.vue?vue&type=template&id=38c3c1f8&scoped=true&ts=true"
import script from "./Links.vue?vue&type=script&lang=ts"
export * from "./Links.vue?vue&type=script&lang=ts"

import "./Links.vue?vue&type=style&index=0&id=38c3c1f8&lang=scss&scoped=true"

import exportComponent from "/workspace/hound-platform/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38c3c1f8"]])

export default __exports__